var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.itemClass,on:{"click":_vm.handleClick}},[(_vm.showRadio)?_c('span',{staticClass:"radio"}):_vm._e(),_c('img',{attrs:{"src":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }